import React from 'react';
import { fromPairs, map, get, isEqual } from 'lodash';
import { button as Button } from 'modules/button';
import { Form } from 'modules/form';
import classnames from 'classnames';


// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberEscalationCall as MemberEscalationCall } from 'ui/views/widgets/memberEscalationCall';
 *
 * // render
 * <MemberEscalationCall propName='propValue'/>
 */
export const memberEscalationCall = ( props ) => {

    // field
    const title = props.title ;

    const { actions = [] } = props;

    return (
        <div className='ui-member-escalation-call'>
			<div className='ui-member-escalation-call__header'>

				{/* title for the modal */}
				<div className='ui-member-escalation-call__header__title'>
					{ getLabel( title ) }
				</div>

				{/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>

			</div>

            <div className='ui-member-escalation-call__body'>

                <Form
                    fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                    values={ props.values } // default values
                    isValid={ false }
                    
                    // key={ props.formId }
                    onChangeCallBack={ props.onChangeCallBack }
                    onSubmit={ ( { values, isValid } ) => {

                        if( isValid ) {
                            props.onFormSubmit( {
                                ...values
                            } );
                        }

                        //props.onSumbitClick( { values, isValid } );

                    } }
                >
                    { ( { fields, values, /*isValid,*/ errors, onChange, onSumbit } = {} ) => {

                        return (
                            <form
                                onSubmit={ onSumbit }
                                className='ui-member-escalation-call__body__form'
                            >
                                { /* fields */ }
                                { map( fields, ( field ) => {

                                    if( get( field, 'config.hide' ) ) {
                                        return null;
                                    }
                                    
                                    const className = classnames(
                                        'ui-member-escalation-call__body__form__field',
                                        `ui-member-escalation-call__body__form__field--${ field.name }`
                                    );

                                    return (
                                        <field.view
                                            className={ className }
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            config={ field.config }
                                            placeholder={ field.placeholder }
                                            label={ field.title }
                                            onChange={ onChange }
                                            value={ values[ field.name ] }
                                            error={ errors[ field.name ] }
                                            options={ get( props.options, field.options ) }
                                            mask={ field.mask }
                                        />
                                    );
                                } ) }

                                {/* button actions */}
                                <div className='ui-member-escalation-call__body__actions'>
                                    { map( actions, action => {
                                        return (
                                            <Button
                                                { ...action }
                                                key={ action.name }
                                                id= { action.name }

                                                type= { 'cancel' !== action.name ? 'submit' : 'button' }

                                                // disabled={ 'cancel' !== action.name ? !isValid : false }
                                                outline={ 'cancel' === action.name ? true: false }
                                                size='large'
                                                className='ui-member-escalation-call__body__actions__action'
                                                onClick = { isEqual( 'cancel', action.name ) ? () => {
                                                    props.closeOverlay();
                                                } : null }
                                            />
                                        );
                                    } ) }
                                </div>

                            </form>
                        );
                    } }
                </Form>
            </div>
           
        </div>
    );
};

// set display name
memberEscalationCall.displayName = 'memberEscalationCall';

// set default props
memberEscalationCall.defaultProps = {};

// prop types
memberEscalationCall.propTypes = {};
